import request from '@/utils/axios';
import { ResponseData } from '@/utils/axios';

/**
 * 联系我们请求参数
 */
export interface ContactUsRequest {
    /**
     * 邮箱地址
     */
    email?: null | string;
    /**
     * 留言内容
     */
    message?: null | string;
    /**
     * 姓名
     */
    name?: null | string;
    [property: string]: any;
}

/**
 * 联系我们响应
 */
export interface ContactUsResponse {
    /**
     * 响应状态码(1000=成功，-1000=失败，-99=异常）
     */
    code?: number;
    /**
     * 响应数据
     */
    data?: null;
    /**
     * 响应状态消息
     */
    message?: string;
    [property: string]: any;
}

// NC API (Network and Communication)
export const ncApi = {
    /**
     * 提交联系我们表单
     * @param params 联系我们表单参数
     * @returns 
     */
    contactUs: (params: ContactUsRequest): Promise<ResponseData<null>> => {
        return request({
            url: '/nc/crm/contract/us',
            method: 'POST',
            data: params
        });
    }
}; 